var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContainer',{staticClass:"mr-12",attrs:{"fluid":""}},[_c('VRow',{attrs:{"dense":""}},[_c('v-checkbox',{staticClass:"mt-0 pt-0",attrs:{"value":_vm.checked},on:{"change":_vm.handleChange},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{staticClass:"newest-codes-label"},[_vm._v("Newest Codes Only")])]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }